module.exports = "//static.hsappstatic.net/LoginUI/static-1.13847/img/google-logo.png"